module.exports = __webpack_public_path__ + "img/xu5-3.18d6ef29.png";